<div class="wrapper-product">
  <div class="wrapper-product-content">
    <ui-product-card-core
      [showCheckbox]="showCheckbox()"
      [product]="product()"
      [displayListView]="true"
      [selected]="selected()"
      (selectedChange)="selected.set($event)"
      [showAttributes]="isSapBundle()"
      [badgeLabelGroups]="['product-badges', 'product-list-view-badges']"
      [enableProductClickTracking]="enableProductClickTracking()"
    >
    </ui-product-card-core>
    <div class="wrapper-price">
      <div class="wrapper-controls">
        <span>Menge</span>
        @if (!readonly()) {
          <ui-form-quantity-counter
            [data]="quantityCounterConfig()"
            [formControl]="quantityCounterControl()"
            [loading]="isQuantityChangeLoading()"
            class="text-bold"
          ></ui-form-quantity-counter>
        } @else {
          <span>{{ productItem().quantity }}</span>
        }
      </div>
      <ng-template uiProductPriceVisibility [prices]="product().prices" let-prices>
        <div>
          <span>Einzelpreis</span>
          <ui-product-prices-formatter [price]="prices.singleUnit"></ui-product-prices-formatter>
        </div>

        <div>
          <span>Preis je VE</span>
          <ui-product-prices-formatter [price]="prices.salesUnit"></ui-product-prices-formatter>
        </div>

        <div>
          <span class="bundle-price">Gesamt</span>
          <ui-product-prices-formatter
            [price]="(prices.bundlePrice ?? 0) * productItem().quantity">
          </ui-product-prices-formatter>
        </div>
      </ng-template>
    </div>
  </div>

  @if (!readonly()) {
    <div class="wrapper-remove">
      <button (click)="removed.emit(productItem())" [disabled]="isRemoveLoading()">
        @if (isRemoveLoading()) {
          <ui-icon class="spinner" [faName]="'spinner-third'" [faStyle]="'light'" animation="spin"></ui-icon>
        } @else {
          <ui-icon faName="trash" faStyle="light"></ui-icon>
        }

        Löschen
      </button>
    </div>
  }
  <hr>
</div>

@for (bundledProduct of bundledProducts(); track bundledProduct.id + bundledProduct.quantity; ) {
  <div class="wrapper-product" [class.with-checkbox]="showCheckbox()" [class.free-product]="bundledProduct.isFree">
    <div class="wrapper-product-content">
      <ui-product-card-core
        [product]="bundledProduct"
        [displayListView]="true"
        [showAttributes]="!bundledProduct.isFree"
        [enableProductClickTracking]="enableProductClickTracking()"
        [position]="$index"
      >
      </ui-product-card-core>

      <div class="wrapper-price">
        <div>
          <span>Menge</span>
          <span>{{ bundledProduct.quantity }}</span>
        </div>

        <ng-template uiProductPriceVisibility [prices]="bundledProduct.prices">
          @let bundlePrices = bundledProduct.prices;
          @if (bundledProduct.isFree) {
            <div>
              <span class="bundle-price">Gesamt</span>
              <span class="free-label">Gratis</span>
            </div>
          } @else if (bundlePrices) {
            <div>
              <span>Einzelpreis</span>
              <ui-product-prices-formatter [price]="bundlePrices.singleUnit"></ui-product-prices-formatter>
            </div>

            <div>
              <span>Preis je VE</span>
              <ui-product-prices-formatter [price]="bundlePrices.salesUnit"></ui-product-prices-formatter>
            </div>

            <div>
              <span class="bundle-price">Gesamt</span>
              <ui-product-prices-formatter
                [price]="bundlePrices.salesUnit * bundledProduct.quantity">
              </ui-product-prices-formatter>
            </div>

            @if (bundlePrices.salesUnitDeposit; as salesUnitDeposit) {
              <div class="wrapper-deposit">
                <span>Pfand (zzgl.)</span>
                <ui-product-prices-formatter
                  [price]="salesUnitDeposit * bundledProduct.quantity">
                </ui-product-prices-formatter>
              </div>
            }
          }
        </ng-template>
      </div>
    </div>
    <hr>
  </div>
}

<ng-template uiProductPriceVisibility [prices]="product().prices" let-prices>
  <div class="wrapper-bundle-price">
    <span>Paketpreis</span>
    <ui-product-prices-formatter [price]="prices.bundlePrice ?? 0"></ui-product-prices-formatter>
  </div>
</ng-template>
